import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-companyrules',
  templateUrl: './view-companyrules.component.html',
  styleUrls: ['./view-companyrules.component.scss']
})
export class ViewCompanyrulesComponent implements OnInit {
  @Input() viewCompanyRules;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log(this.viewCompanyRules);
    
  }

  closeModal(sendData) {
    this.activeModal.close(sendData);
  }

}
